const m = ["BG_REMOVAL", "UPSCALE"], Y = 100, V = 1e4, k = {
  BG_REMOVAL: "Background removal",
  UPSCALE: "Image enhancement"
}, x = "a1e0c0de-0000-4000-8000-000000000001", A = {
  BG_REMOVAL: "a1e0c0de-0000-4000-8000-000000000002",
  UPSCALE: "a1e0c0de-0000-4000-8000-000000000003"
}, q = (e) => {
  for (const t of m)
    if (A[t] === e) return t;
  return null;
}, Q = 50 * 1024 * 1024, z = "image/*", K = 150, S = 200, X = 3200, W = 3200, Z = 95, J = 300, j = 300, ee = 85, te = 1500, ne = 40, se = 2e3, ae = /^https:\/\/(placehold\.co|via\.placeholder\.com)\/\d+(?:x\d+)?$/, oe = [
  "designAsset",
  "shape",
  "qrCode",
  "line",
  "watermark",
  "stylizedVerse",
  "logoImage",
  "floralPix"
], ie = S, re = 36e6, de = 3, le = 16383, ce = 18e4, _e = {
  personalInfo: "personalInfo",
  familyInfo: "familyInfo",
  additionalFamily: "additionalFamily",
  serviceInfo: "serviceInfo",
  musicSelections: "musicSelections",
  pallBearersSocieties: "pallBearersSocieties",
  intermentInfo: "intermentInfo",
  memorialContributions: "memorialContributions",
  headers: "headers"
}, Ee = {
  prefix: "prefix",
  first: "first",
  nickname: "nickname",
  middle: "middle",
  last: "last",
  suffix: "suffix",
  maiden: "maiden"
}, me = {
  prefix: "Prefix",
  first: "First Name",
  nickname: '"Nickname"',
  middle: "Middle Name",
  last: "Last Name",
  suffix: "Suffix",
  maiden: "(Maiden Name)"
}, Ae = {
  sectionLabel: "sectionLabel",
  input: "input",
  date: "date",
  array: "array",
  mappedArray: "mappedArray",
  nestedArray: "nestedArray",
  textarea: "textarea",
  check: "check",
  blank: "blank"
}, Se = {
  sectionLabel: "section_label",
  editableCaseId: "editable_case_id",
  prefix: "prefix_dec",
  firstName: "first_dec",
  nickName: "nick_name_dec",
  middleName: "middle_dec",
  maidenName: "maiden_dec",
  lastName: "lastdec",
  // TODO: backend uses lastdec, so have to use this for now (should be last_dec)
  suffix: "suffix_dec",
  dateOfBirth: "date_of_birth",
  dateOfDeath: "date_of_death",
  placeOfBirth: "place_of_birth",
  placeOfDeath: "place_of_death",
  motherOfDeceased: "mother_of_deceased",
  fatherOfDeceased: "father_of_deceased",
  spouse: "spouse",
  dateOfMarriage: "date_of_marriage",
  siblings: "siblings",
  children: "children",
  additionalFamily: "additional_family",
  maternalGrandmother: "maternal_grandmother",
  maternalGrandmothersMother: "maternal_grandmothers_mother",
  maternalGrandmothersFather: "maternal_grandmothers_father",
  maternalGrandfather: "maternal_grandfather",
  maternalGrandfathersMother: "maternal_grandfathers_mother",
  maternalGrandfathersFather: "maternal_grandfathers_father",
  paternalGrandmother: "paternal_grandmother",
  paternalGrandmothersMother: "paternal_grandmothers_mother",
  paternalGrandmothersFather: "paternal_grandmothers_father",
  paternalGrandfather: "paternal_grandfather",
  paternalGrandfathersMother: "paternal_grandfathers_mother",
  paternalGrandfathersFather: "paternal_grandfathers_father",
  familyAppreciationMessage: "family_appreciation_message",
  services: "services",
  orderOfService: "order_of_service",
  clergy: "clergy",
  songs: "songs",
  pallbearers: "pallbearers",
  organizations: "organizations",
  memorialContributions: "memorial_contributions",
  intermentTime: "interment_time",
  intermentDate: "interment_date",
  intermentPlace: "interment_place",
  intermentAddress: "interment_address",
  intermentCity: "interment_city",
  intermentState: "interment_state",
  intermentPostalCode: "interment_postal_code",
  birthHeader: "case_preferences.birth_header",
  deathHeader: "case_preferences.death_header",
  remembranceHeader: "case_preferences.remembrance_header",
  officiatingHeader: "case_preferences.officiating_header",
  memorialServiceHeader: "case_preferences.memorial_service_header",
  pallbearersHeader: "case_preferences.pallbearers_header",
  visitationHeader: "case_preferences.visitation_header",
  finalRestingHeader: "case_preferences.final_resting_header",
  familyAppreciationHeader: "case_preferences.family_appreciation_header"
}, Te = {
  personalInfo: "Personal Information",
  editableCaseId: "Custom case ID",
  prefix: "Prefix name",
  firstName: "First name",
  nickName: "Nickname",
  middleName: "Middle name",
  maidenName: "Maiden name",
  lastName: "Last name",
  suffix: "Suffix name",
  dateOfBirth: "Date of birth *",
  dateOfDeath: "Date of death",
  placeOfBirth: "Place of birth",
  placeOfDeath: "Place of death",
  parents: "Parents",
  motherOfDeceased: "Mother full name",
  fatherOfDeceased: "Father full name",
  spouse: "Spouse full name",
  dateOfMarriage: "Date of marriage",
  siblings: "Siblings",
  sibling: "Sibling",
  children: "Children",
  child: "Child",
  additionalFamily: "Additional Family",
  genealogy: "Genealogy",
  mothersSide: "Mother's Side",
  fathersSide: "Father's Side",
  grandmother: "Grandmother",
  grandfather: "Grandfather",
  greatGrandmother: "Great grandmother",
  greatGrandfather: "Great grandfather",
  grandmothersParents: "Grandmother's parents",
  grandfathersParents: "Grandfather's parents",
  precededBySurvivedByGrandchildren: "Preceded By, Survived By, Grandchildren etc.",
  addAnotherGroup: "Add Another Group",
  orderOfService: "Order of service",
  clergy: "Clergy",
  musicSelections: "Music Selections",
  song: "Song",
  intermentInfo: "Interment Info",
  intermentTime: "Interment Time",
  intermentDate: "Interment Date",
  intermentPlace: "Interment Place",
  intermentAddress: "Interment Address",
  intermentCity: "Interment City",
  intermentState: "Interment State",
  intermentPostalCode: "Interment Postal Code",
  birthHeader: "Date of Birth",
  deathHeader: "Date of Death",
  remembranceHeader: "Remembrance",
  officiatingHeader: "Officiating",
  memorialServiceHeader: "Memorial Service",
  pallbearersHeader: "Pallbearers Header",
  visitationHeader: "Visitation",
  finalRestingHeader: "Final Resting",
  familyAppreciationHeader: "Family Appreciation"
}, Ie = {
  visitation: "visitation",
  service: "service",
  pallbearer: "pallbearer",
  honoraryPallbearer: "honorary pallbearer",
  organization: "organization",
  memorialContribution: "memorial contribution"
}, ue = {
  additionalFamily: ["name", "relation", "city", "state", "country"],
  services: [
    { field: "location", type: "input" },
    { field: "city", type: "input" },
    { field: "state", type: "input" },
    { field: "date", type: "date" },
    { field: "start_time", type: "input" },
    { field: "end_time", type: "input" },
    { field: "clergy_place", type: "input" },
    { field: "room_chapel", type: "input" },
    { field: "address", type: "input" },
    { field: "postal_code", type: "input" },
    { field: "country", type: "input" },
    { field: "default", type: "check" }
  ],
  pallbearers: [
    { field: "name", type: "input" },
    { field: "sequence", type: "input" }
  ],
  organizations: [
    { field: "name", type: "input" },
    { field: "address1", type: "input" },
    { field: "address2", type: "input" },
    { field: "city", type: "input" },
    { field: "state", type: "input" },
    { field: "zip_code", type: "input" },
    { field: "country", type: "input" },
    { field: "website_url", type: "input" },
    { field: "sequence", type: "input" }
  ],
  memorialContributions: [
    { field: "charity_of_choice", type: "check" },
    { field: "name", type: "input" },
    { field: "sequence", type: "input" }
  ]
}, Oe = {
  service: {
    location: null,
    city: null,
    state: null,
    date: "",
    time: null,
    start_time: "",
    end_time: null,
    clergy_place: null,
    room_chapel: null,
    address: null,
    postal_code: null,
    country: null,
    default: !1
  },
  additionalFamily: {
    name: null,
    relation: null,
    city: null,
    state: null,
    country: null
  },
  pallbearers: {
    name: null,
    sequence: null
  },
  organizations: {
    name: null,
    address1: null,
    address2: null,
    city: null,
    state: null,
    zip_code: null,
    country: null,
    website_url: null,
    sequence: null
  },
  memorialContributions: {
    charity_of_choice: !1,
    name: null,
    sequence: null
  }
}, pe = {
  hidden: {
    sequence: "sequence"
  }
}, ge = 300, fe = {
  DECEASED_INFO: "Deceased Info",
  OBITUARY: "Obituary",
  SERVICE_INFO: "Service Info",
  IMAGES_AND_FAMILY: "Images",
  CASE_PREFERENCES: "Case Preferences"
}, he = ["M3", "MDL"], Ne = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/, De = "client-credentials", Re = 3e4, Pe = 3e3, Le = "M/D [at] h:mm a", T = "designRequestNotify", I = "rasterizeProofPdf", u = 25 * 1024 * 1024, d = u / (1024 * 1024), Ce = 100, Me = (e) => `${I}:${e}`, ye = 4e3, Ge = 3 * 6e4, Fe = (e) => `${T}:${e}`, Ue = {
  title: "Designer Space",
  overview: "Overview",
  customDesigns: "Custom Designs",
  queue: "Queue",
  myItems: "My Inbox",
  qualityAssurance: "Quality Assurance",
  comingSoon: "Coming soon.",
  // Queue urgency pills, from the request's frozen need-by urgency.
  urgency: {
    LOW: "Low",
    MEDIUM: "Medium",
    HIGH: "High",
    RUSH: "Rush"
  },
  // Overview page
  greeting: "Hello",
  yourTasks: "Your Tasks",
  recentActivity: "Recent Activity",
  messages: "Messages",
  comments: "Comments",
  all: "All",
  unread: "Unread",
  previousPage: "Previous page",
  nextPage: "Next page",
  pageSummary: (e, t, n) => `${e}-${t} of ${n}`,
  // Task-card stat lines (counts come from the live overview endpoint).
  taskLines: {
    unreadMessages: (e) => `${e} unread ${e === 1 ? "message" : "messages"}`,
    messagesAwaitingReply: (e) => `${e} ${e === 1 ? "message" : "messages"} awaiting reply`,
    unreadComments: (e) => `${e} unread ${e === 1 ? "comment" : "comments"}`,
    commentsAwaitingReply: (e) => `${e} ${e === 1 ? "comment" : "comments"} awaiting reply`,
    designsUnassigned: (e) => `${e} ${e === 1 ? "design" : "designs"} unassigned`,
    designsAssigned: (e) => `${e} ${e === 1 ? "design" : "designs"} assigned to you`
  },
  // Queue view
  queueFilters: {
    all: "All",
    assignedToMe: "Assigned to me",
    unassigned: "Unassigned"
  },
  queueSections: {
    TODO: "To Do",
    IN_PROGRESS: "In Progress",
    PROOF_APPROVED: "Proof Approved",
    COMPLETED: "Order Completed",
    CANCELED: "Canceled"
  },
  queueTooltips: {
    unreadActivity: "Unread activity",
    estimatedDesignTime: "Estimated design time",
    // Per-level urgency copy, mirroring the need-by windows the urgency
    // derives from.
    urgency: {
      RUSH: "This item is needed today",
      HIGH: "This item is needed in 2-3 days",
      MEDIUM: "This item is needed within 5 days",
      LOW: "This item is needed over 5 days from now"
    },
    assignedTo: "Assigned to",
    needBy: "Need by"
  },
  // The filter panel beside search: one row per facet, each control
  // reading "All" until something is picked.
  // The inbox filter chips beside the title.
  inboxFilters: {
    allActive: "All Active",
    unread: "Unread",
    past: "Past"
  },
  inboxFilterButton: "Filter inbox",
  queueFilterPanel: {
    button: "Filter queue",
    all: "All",
    clearAll: "Clear All Filters",
    removeFilter: "Remove filter",
    status: "Status",
    estimatedDesignTime: "Estimated Design Time",
    priority: "Priority",
    product: "Product",
    designService: "Design Service",
    assignedTo: "Assigned To",
    clientName: "Client Name",
    needBy: "Need By",
    // Estimated-time buckets over the summed service minutes.
    timeBuckets: {
      UNDER_1: "<1 hour",
      FROM_1_TO_2: "1-2 hours",
      FROM_2_TO_3: "2-3 hours",
      OVER_3: ">3 hours"
    },
    priorities: {
      LOW: "Low",
      MEDIUM: "Medium",
      HIGH: "High",
      RUSH: "Rush"
    }
  },
  // The MDL editor's designer send-proof button and modal.
  sendProof: {
    button: "Send proof to client",
    title: "Send proof to client",
    noteLabel: "Note",
    noteHelper: "Let the client know what changed.",
    suggestAddOn: "Suggest an add-on",
    cancel: "Cancel",
    send: "Send",
    sending: "Sending…",
    sent: "Proof sent — the client sees it once the pages finish rendering.",
    sentReused: "Proof sent to the client.",
    sentBadge: "Proof sent",
    failed: "Sending the proof failed. Please try again."
  },
  // The Log Time dialog: Harvest-style time entry on an assigned request.
  logTime: {
    title: "Log Time",
    timeSpent: "Time Spent",
    placeholder: "0:05",
    cancel: "Cancel",
    log: "Log",
    logged: "Time logged.",
    invalid: "Enter time as hours (1.5) or h:mm (1:30).",
    service: "Service",
    // "1.5 hours estimated · 2 hours logged · $100.00"
    serviceSummary: (e, t, n) => `${e} estimated · ${t} logged · ${n}`
  },
  // The queue's quick-view drawer: header, unread-alert cards, and CTAs.
  quickView: {
    design: "Design",
    goToPortal: "Go To Portal",
    close: "Close",
    needBy: "Need By",
    sentMessage: (e) => `${e} sent you a message`,
    addedComment: (e) => `${e} added a comment to the proof`,
    addedService: (e) => `${e} added a service`,
    approvedProofOn: (e, t) => `${e} approved the proof on ${t}`,
    addedServiceQuote: (e) => `Additional Design Time at ${e}`,
    serviceQuote: (e, t) => `${e} at ${t}`
  },
  // Shown on the Unassigned view once every open request is claimed.
  queueEmptyUnassigned: {
    title: "No Unassigned Items",
    subtitle: "All open requests have been claimed by a designer.",
    viewMyItems: "View My Items",
    viewAllItems: "View All Items"
  },
  assignToMe: "Assign To Me",
  unassignedLabel: "Unassigned",
  me: "Me",
  reassignToMe: "Reassign To Me",
  reassignLabel: "Reassign",
  // Takeover / hand-off confirmation modal.
  reassignModal: {
    takeoverTitle: "Reassign To Me",
    takeoverBody: (e) => `This will move the request out of ${e}'s queue and into yours. You'll take over the full conversation history, proofs, and attachments.`,
    takeoverBodyUnnamed: "This will move the request into your queue. You'll take over the full conversation history, proofs, and attachments.",
    pickTitle: "Reassign Request",
    pickBody: "Move this request to another designer. They take over the full conversation history, proofs, and attachments.",
    pickLabel: "Assign To",
    confirm: "Reassign",
    cancel: "Cancel",
    success: "Request reassigned",
    failure: "Failed to reassign request"
  },
  searchPlaceholder: "Search",
  estimatedHours: (e) => `${e} ${e === 1 ? "hour" : "hours"}`,
  // My Items workspace
  myItemsView: {
    activity: "Activity",
    clientInfo: "Client Info",
    designedBefore: "You've designed for this client before.",
    viewPastDesigns: "View Past Designs",
    designService: "Design Service",
    pricing: "Pricing",
    item: "Item",
    designServices: "Design Services",
    subtotal: "Subtotal",
    estimatedDesignTime: "Estimated Design Time",
    designTimeUsed: "Design Time Used",
    design: "Design",
    logTime: "Log Time",
    viewDesignDetails: "View Design Details",
    typeMessage: "Type your message...",
    newMessages: "New messages",
    addServices: "Add Services",
    attachPhotosOrDocuments: "Attach Photos Or Documents",
    viewProof: "View Proof",
    messagePreview: (e, t) => `${e}: ${t}`,
    you: "You",
    selectAnItem: "Select an item to open its conversation.",
    noItems: "Nothing is assigned to you yet — claim work from the Queue.",
    submittedItem: (e) => `${e} submitted an item for design`,
    sentProof: (e) => `You sent ${e} a proof`,
    commentedOnProof: (e) => `${e} commented on your proof`,
    youCommented: "You added a comment to the proof",
    viewComment: "View Comment",
    clientDeclinedService: (e, t) => `${e} declined ${t}`,
    approvedProofOn: (e, t) => `${e} approved this proof on ${t}`,
    orderSubmittedOn: (e) => `Order submitted on ${e}`,
    orderCanceledOn: (e) => `Order canceled on ${e}`,
    addedAdditionalTime: (e, t) => `${e} added Additional Design Time at ${t}`,
    sentAddOnSuggestion: (e, t) => `You sent ${e} an add-on suggestion for ${t}`,
    youSentAttachment: "You sent an attachment",
    clientSentAttachment: (e) => `${e} sent an attachment`,
    download: "Download",
    removeAttachment: "Remove",
    attachmentUploadFailed: "Uploading the attachment failed. Please try again.",
    proofReviewed: "Proof Reviewed",
    proofApproved: "Proof Approved",
    estimatedTimeLine: (e) => `Estimated design time: ${e}`,
    clientAddedService: (e, t, n) => `${e} added ${t} at ${n}`,
    caseLabel: (e) => `Case: ${e}`,
    serviceLabel: (e) => `Service: ${e}`,
    // Per-service intake summaries on the submission card, one line per
    // selected service that collected content.
    photoPlacementLine: (e) => `Photo placement: ${e}`,
    themeLine: (e) => `Theme: ${e}`,
    orderOfServiceLine: (e) => `Order of Service: ${e}`,
    layoutChangesLine: (e) => `Layout Changes: ${e}`,
    photoEditsLine: (e, t) => `Photo Edits: ${e} of ${t} photos selected`,
    additionalPhotosLine: (e, t) => `Additional Photos: ${e} of ${t} photos selected`
  },
  // The Design Details modal: the request's product specs plus everything
  // the intake prompts collected.
  // The plus menu beside the designer's chat input.
  composerMenu: {
    suggestAddOns: "Suggest Add-Ons",
    attachFiles: "Attach Photos Or Documents",
    uploadProof: "Upload Proof",
    openMenu: "More actions"
  },
  // The Upload Proof modal: a proof made outside the editor (Signature by
  // Beryl) sent to the client as a PDF.
  uploadProof: {
    title: "Send proof to client",
    proofLabel: "Proof",
    finalLabel: "Final product",
    fileHint: `PDF up to ${d}MB`,
    wrongType: "Only a PDF can be sent.",
    tooLarge: `That PDF is over ${d}MB.`,
    noteLabel: "Note",
    noteHelper: "Let the client know what changed.",
    suggestAddOn: "Suggest an add-on",
    cancel: "Cancel",
    send: "Send",
    sending: "Sending…",
    sent: "Proof sent — the client sees it once the pages finish rendering.",
    uploadFailed: "Uploading the PDF failed. Please try again."
  },
  // The Suggest Add-Ons modal: upsell services picked from chat.
  suggestAddOns: {
    title: "Suggest Add-Ons",
    message: "Message",
    messageHelper: "Let the client know why you're suggesting this.",
    cancel: "Cancel",
    send: "Suggest Add-On",
    sent: "Suggestion sent"
  },
  designDetails: {
    title: "Design Details",
    priceEach: (e) => `${e} Each`,
    design: "Design",
    close: "Close",
    theme: "Theme",
    pageCount: "Page Count",
    quantity: "Quantity",
    needByDate: "Need By Date",
    photoPlacement: "Photo Placement",
    orderOfService: "Order Of Service",
    layoutChanges: "Layout Changes",
    noPlacementNotes: "No placement notes",
    placementSelf: "I'll choose myself",
    placementDesigner: "Designer chooses placement"
  },
  // Activity-row titles, keyed by the customer event that produced them.
  activityTitles: {
    SUBMITTED: (e) => `${e} submitted an item for design`,
    MESSAGE: (e) => `${e} sent you a message`,
    COMMENT: (e) => `${e} commented on your proof`,
    PROOF_APPROVED: (e) => `${e} approved your proof`,
    ADDITIONAL_TIME: (e) => `${e} added Additional Design Time`,
    SERVICE_ADDED: (e) => `${e} added a service`,
    SERVICE_DECLINED: (e) => `${e} declined a service`
  }
}, ve = {
  /** The customer's personalize access (funeral-home user editor). */
  FH_ADMIN: "FH_ADMIN",
  /** Design staff: the full admin-level editor. */
  DESIGNER: "DESIGNER",
  /** The order's never-expiring QC token: full admin-level editor. */
  QC: "QC"
}, O = "access", be = "token", p = ["token", "fh_admin"], we = "qc_shadow", He = {
  MESSENGER: "messenger-user",
  FH: "fh-user"
}, Be = (e) => p.includes(
  new URLSearchParams(e).get(O) ?? ""
), $e = "x-edit-token", Ye = {
  role: "editTokenRole",
  scopeOrderProductId: "editTokenScopeProductId",
  // The raw token, kept for designer and QC sessions: it is sent beside
  // x-order on each request, so the backend reads the session's role from
  // it, and it authenticates a designer's send-proof calls.
  token: "editToken"
}, g = {
  BAD_REQUEST: "BAD_REQUEST",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  CONFLICT: "CONFLICT",
  PRECONDITION_FAILED: "PRECONDITION_FAILED",
  GONE: "GONE",
  TOO_MANY_REQUESTS: "TOO_MANY_REQUESTS",
  UNSUPPORTED_IMAGE_FORMAT: "UNSUPPORTED_IMAGE_FORMAT",
  FILE_TOO_LARGE: "FILE_TOO_LARGE",
  IMAGE_IN_USE_BY_LAYOUT: "IMAGE_IN_USE_BY_LAYOUT",
  // A reorder would copy text boxes onto an order whose funeral home may not
  // hold them, so nothing was added.
  LAYOUT_TEXT_NOT_AVAILABLE: "LAYOUT_TEXT_NOT_AVAILABLE",
  // The AI image edits switch (Site Settings > AI Image Edits in M3) is off,
  // so no background removal or Enhance may start or be accepted.
  AI_IMAGE_EDITS_DISABLED: "AI_IMAGE_EDITS_DISABLED",
  INTERNAL_SERVER_ERROR: "INTERNAL_SERVER_ERROR"
}, Ve = "order_page_gone", ke = "order_page_turned_over", xe = "lotus_funeral_home_not_enabled", qe = "lotus_global_template_refused", Qe = "layout_saver_has_no_funeral_home", ze = "dignity direct", Ke = "M3", Xe = "MDL", We = "https://videos.tukios.com", Ze = "6f2aa94b-641c-4ad7-a01a-12817c30a52c", Je = "f7fb0a28-824e-4916-8d52-1c1f689b9bcc", je = {
  image: "image",
  text: "text",
  shape: "shape",
  line: "line",
  qrCode: "qrCode",
  editorTextBox: "editorTextBox"
}, et = 96, tt = {
  ERROR: "error",
  WARN: "warn",
  INFO: "info",
  DEBUG: "debug"
}, nt = {
  CLICK: "click",
  AUTH: "auth",
  API: "api",
  NAVIGATION: "navigation",
  ERROR: "error",
  PERFORMANCE: "performance",
  SAVE: "save",
  REMOVE: "remove",
  EDIT: "edit",
  CREATE: "create",
  SEARCH: "search",
  CANCEL: "cancel",
  SUBMIT: "submit",
  CLOSE: "close",
  OPEN: "open",
  TOGGLE: "toggle",
  SHOW: "show",
  HIDE: "hide",
  INSERT: "insert",
  FORMAT: "format",
  DISCREPANCY: "discrepancy"
}, st = 47, at = "proofShareFinalize", ot = "Screenshot generation failed", it = [
  /Invalid call to runtime\.sendMessage/i,
  /Tab not found/i,
  /Extension context invalidated/i,
  // Meta (Facebook / Instagram) in-app browser injected telemetry. Its Android
  // WebView Java↔JS bridge object is garbage-collected on page unload, so the
  // injected beacon call rejects with "Java object is gone". Not an app bug.
  // Message-level backstop for the frameless case (denyUrls can't see those).
  // Origin issue: Sentry MDL-FRONTEND-EE.
  /Java object is gone/i,
  /Error invoking .*enableButtonsClickedMetaDataLogging/i
], rt = [
  /^chrome-extension:\/\//,
  /^moz-extension:\/\//,
  /^safari-(web-)?extension:\/\//,
  // Meta in-app browser injected scripts load under the iabjs:// scheme
  // (e.g. iabjs://navigation_performance_logger_android). Dropping the scheme
  // filters the whole class of Facebook / Instagram in-app-browser noise by
  // stack frame. Origin issue: Sentry MDL-FRONTEND-EE.
  /^iabjs:\/\//
], dt = {
  autocorrect: "off",
  autocapitalize: "off",
  spellcheck: "false",
  writingsuggestions: "false",
  translate: "no",
  "data-gramm": "false",
  "data-gramm_editor": "false",
  "data-enable-grammarly": "false"
}, lt = {
  PLAIN: "PLAIN",
  PREPRINTED: "PREPRINTED"
}, ct = {
  QUEUED: "QUEUED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
}, _t = {
  queued: "queued",
  processing: "processing",
  completed: "completed",
  failed: "failed"
}, Et = {
  BG_REMOVAL: "BG_REMOVAL",
  UPSCALE: "UPSCALE"
}, mt = {
  bg_removal: "bg_removal",
  upscale: "upscale"
}, f = {
  DAILY_CAP_REACHED: "DAILY_CAP_REACHED",
  MODERATION_BLOCKED: "MODERATION_BLOCKED",
  SPEND_LIMIT: "SPEND_LIMIT",
  NOT_CONFIGURED: "NOT_CONFIGURED",
  MODEL_ERROR: "MODEL_ERROR",
  ENQUEUE_FAILED: "ENQUEUE_FAILED",
  ASPECT_UNSUPPORTED: "ASPECT_UNSUPPORTED",
  AI_IMAGE_EDITS_DISABLED: g.AI_IMAGE_EDITS_DISABLED
}, h = new Set(
  Object.values(f)
), At = (e) => h.has(e), St = {
  IN_QUEUE: "IN_QUEUE",
  GENERATING: "GENERATING",
  COMPLETE: "COMPLETE",
  TIMEOUT: "TIMEOUT",
  ERROR: "ERROR",
  PROOF_ONLY: "PROOF_ONLY"
}, Tt = {
  in_queue: "in_queue",
  generating: "generating",
  complete: "complete",
  timeout: "timeout",
  error: "error",
  proof_only: "proof_only"
}, s = {
  INITIALIZATION: "INITIALIZATION",
  DATA_FETCHING: "DATA_FETCHING",
  PAGE_ACQUISITION: "PAGE_ACQUISITION",
  PAGE_SETUP: "PAGE_SETUP",
  NAVIGATION: "NAVIGATION",
  CONTENT_LOADING: "CONTENT_LOADING",
  PDF_GENERATION: "PDF_GENERATION",
  GHOSTSCRIPT_PROCESSING: "GHOSTSCRIPT_PROCESSING",
  S3_UPLOAD: "S3_UPLOAD",
  FINALIZATION: "FINALIZATION"
}, It = {
  [s.INITIALIZATION]: { start: 0, end: 5 },
  [s.DATA_FETCHING]: { start: 5, end: 15 },
  [s.PAGE_ACQUISITION]: { start: 15, end: 20 },
  [s.PAGE_SETUP]: { start: 20, end: 30 },
  [s.NAVIGATION]: { start: 30, end: 45 },
  [s.CONTENT_LOADING]: { start: 45, end: 60 },
  [s.PDF_GENERATION]: { start: 60, end: 70 },
  [s.GHOSTSCRIPT_PROCESSING]: { start: 70, end: 80 },
  [s.S3_UPLOAD]: { start: 80, end: 95 },
  [s.FINALIZATION]: { start: 95, end: 100 }
}, ut = {
  EDITING: "EDITING",
  PROOF_SENT: "PROOF_SENT",
  FINALIZED: "FINALIZED",
  CLOSED: "CLOSED"
}, Ot = {
  editing: "editing",
  proof_sent: "proof_sent",
  finalized: "finalized",
  closed: "closed"
}, pt = {
  pdfProduct: "pdfProduct",
  pdfProofProduct: "pdfProofProduct",
  finals: "finals",
  proofs: "proofs",
  pdfPrint: "pdfPrint"
}, i = (e) => e, N = (e) => e, D = {
  EN: "EN",
  ES: "ES",
  FR: "FR"
}, gt = "en", ft = i({
  EN: "en",
  ES: "es",
  FR: "fr"
}), ht = i({
  EN: "English",
  ES: "Spanish",
  FR: "French"
}), Nt = i({
  EN: "English",
  ES: "Español",
  FR: "Français"
}), R = N({
  EN: { value: "EN", label: "English" },
  ES: { value: "ES", label: "Spanish" },
  FR: { value: "FR", label: "French" }
}), Dt = Object.values(D), Rt = Object.values(R), P = [
  "photoEdits",
  "additionalPhotos",
  "placement",
  "review"
], o = 30, c = (e) => Math.max(
  1,
  Math.ceil(
    (e ?? o) / o
  )
), Pt = 2500, Lt = (e) => {
  const t = c(e.durationMinutes), n = e.unitPriceCents ?? Math.round(e.feeCents / t);
  return { units: t, basePriceCents: n, totalCents: t * n };
}, Ct = (e) => {
  const t = e.loggedMinutes > 0 ? Math.ceil(e.loggedMinutes / o) : c(e.durationMinutes);
  return { units: t, totalCents: t * e.unitPriceCents };
}, L = ["COMPLETED", "CANCELED"], C = (e) => e != null && L.includes(e), M = (e) => e === "PROOF_APPROVED", y = 3, G = 5, Mt = (e) => e.length > 0 && e.length <= y && e.every((t) => t.comment.trim().length > 0), yt = (e) => e.length > 0 && e.length <= G, Gt = {
  photoEdits: "IMAGE_SELECTION",
  additionalPhotos: "IMAGE_SELECTION",
  placement: "IMAGE_SELECTION",
  review: "CASE_REVIEW"
}, F = [
  "IMAGE_SELECTION",
  "CASE_REVIEW",
  "IN_DESIGN"
], U = (e) => F.includes(e), Ft = (e) => !M(e.designRequestStatus) && (U(e.status) || e.designRequestStatus != null && !C(e.designRequestStatus)), v = {
  prompt: null,
  steps: () => ["review"]
}, l = {
  "Standard Theme Design": {
    prompt: "imagePlacement",
    steps: ({ imagePlacementChoice: e }) => e === "self" ? ["placement", "review"] : ["review"]
  },
  // The designer invents the background, so the theme selector is replaced by
  // the custom-theme brief; Continue goes straight to the review modal.
  "Custom Theme Design": {
    prompt: "customTheme",
    steps: () => ["review"]
  },
  // The order-of-service content rides in as a document upload or typed
  // text below the case dropdown; Continue goes straight to review.
  "Order of Service Partner": {
    prompt: "orderOfService",
    steps: () => ["review"]
  },
  // The requested layout adjustments ride in as free text below the case
  // dropdown; Continue goes straight to review.
  "Layout Partner": {
    prompt: "layoutChanges",
    steps: () => ["review"]
  },
  // Photo selections + edit comments are normally collected on the product
  // page; the modal step only runs when the customer hits Continue without
  // finishing them.
  "Photograph Editor": {
    prompt: "photoEdits",
    steps: ({ photoEditsComplete: e }) => e ? ["review"] : ["photoEdits", "review"]
  },
  // The extra photos (uploaded through the case-image pipeline or picked
  // from existing case images) are normally collected on the product page;
  // the modal step only runs when Continue is hit without any added.
  "Additional Photos": {
    prompt: "additionalPhotos",
    steps: ({ additionalPhotosComplete: e }) => e ? ["review"] : ["additionalPhotos", "review"]
  }
}, _ = "Signature by Beryl", Ut = (e) => e.some(
  (t) => t.toLowerCase() === _.toLowerCase()
), b = {
  [_]: "Standard Theme Design",
  "Design my product using a standard theme": "Standard Theme Design",
  "Design my product using a custom theme": "Custom Theme Design",
  "Add an order of service": "Order of Service Partner",
  "Design my layouts": "Layout Partner",
  "Edit my photos": "Photograph Editor",
  "Add more photos": "Additional Photos"
}, w = new Map([
  ...Object.entries(l).map(
    ([e, t]) => [e.toLowerCase(), t]
  ),
  ...Object.entries(b).map(
    ([e, t]) => [e.toLowerCase(), l[t]]
  )
]), r = (e) => w.get(e.toLowerCase()) ?? v, vt = (e) => r(e).prompt, bt = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.forEach((n) => {
    const a = r(n).prompt;
    a && t.add(a);
  }), t;
}, wt = (e, t) => {
  const n = /* @__PURE__ */ new Set();
  return e.forEach((a) => {
    r(a).steps(t).forEach((E) => n.add(E));
  }), P.filter((a) => n.has(a));
}, Ht = [
  "unassigned",
  "assigned",
  "approved",
  "completed",
  "canceled"
], Bt = "/designer/custom-designs/queue", $t = {
  user: "USER",
  superAdmin: "SUPER_ADMIN",
  corporationAdmin: "CORPORATION_ADMIN"
}, H = (e) => e.trim().replace(/^['"]|['"]$/g, ""), Yt = (e) => H(e.split(",")[0] ?? ""), Vt = "#000000", kt = 2, xt = 1, qt = [
  "--no-sandbox",
  "--disable-web-security",
  "--font-render-hinting=none",
  "--disable-dev-shm-usage",
  "--disable-gpu",
  "--disable-setuid-sandbox",
  "--no-first-run",
  "--no-zygote",
  '--js-flags="--max-old-space-size=4096"',
  "--disable-extensions",
  "--disable-background-networking",
  "--disable-default-apps",
  "--disable-sync",
  "--disable-translate",
  "--mute-audio",
  "--disable-component-update",
  "--disable-background-timer-throttling",
  "--disable-renderer-backgrounding",
  "--disable-backgrounding-occluded-windows"
], Qt = 9e4, zt = {
  printBackground: !0
}, Kt = "/usr/share/fonts/google-fonts:/usr/share/fonts/editor-fonts:/usr/share/fonts/root-fonts:/usr/share/fonts", Xt = [
  "-dSAFER",
  "-dBATCH",
  "-dNOPAUSE",
  "-dNOCACHE",
  "-sDEVICE=pdfwrite",
  "-dPreserveAnnots=false",
  "-dAutoRotatePages=/None"
], Wt = /^[A-Za-z0-9_-]*$/, Zt = [
  // Design assets: theme art, backgrounds and product images
  "bassmollett-designassets.s3.us-west-2.amazonaws.com",
  // Case images: photos of the deceased and their Pintura edits
  "bassmollett-caseimages.s3.us-west-2.amazonaws.com",
  // Uploads: images funeral homes upload into the editor
  "bassmollett-uploads.s3.us-west-2.amazonaws.com",
  // Dignity verse images
  "dignity-verses.s3.us-west-2.amazonaws.com",
  // m3 dynamic layout assets: layout images m3 page sets name
  "m3-layout-assets.s3.us-west-2.amazonaws.com",
  // MDL dynamic layout assets: layout images MDL page sets name
  "dignity-layout-assets.s3.us-west-2.amazonaws.com",
  // Path-style S3 host: the bucket is the path's first segment, so a request
  // here is allowed only for a bucket in RENDER_FETCH_ALLOWED_S3_BUCKETS
  "s3-us-west-2.amazonaws.com",
  // Third-party placeholder images stored page content names at scale
  "placehold.co",
  // Third-party placeholder images, the older service
  "via.placeholder.com"
], Jt = "s3-us-west-2.amazonaws.com", jt = [
  // Case images, as stored content and REACT_APP_S3BUCKET_CASE_IMAGES name them
  "bassmollett-caseimages",
  // Uploads, as stored content and REACT_APP_S3BUCKET_UPLOADS name them
  "bassmollett-uploads",
  // Funeral home logos, built from REACT_APP_S3BUCKET_FH_LOGOS
  "bassmollett-funeralhomelogos",
  // Theme backgrounds and watermarks, built from REACT_APP_S3BUCKET_THEME_IMAGES
  "bassmollett-themeimages",
  // Floral images, built from REACT_APP_S3BUCKET_FLORAL_PIX
  "bassmollett-floralpix"
], en = [0, 3], tn = 96 / 72, B = "data-fonts-contract", $ = "1", nn = {
  [B]: $
}, sn = 300 * 1e3, an = 600 * 1e3, on = "Font failed to load";
export {
  m as AI_ALTERATION_KINDS,
  k as AI_ALTERATION_LABEL,
  V as AI_ALTERATION_MAX_PRICE_CENTS,
  A as AI_ALTERATION_OPTION_ID,
  Y as AI_ALTERATION_UNIT_PRICE_CENTS,
  x as AI_IMAGE_EDITS_CUSTOMIZATION_ID,
  De as AUTH0_GTY_CLIENT_CREDENTIALS,
  lt as BACKGROUND_TYPE,
  st as BANNER_PROOF_PDF_MIN_PAGE_HEIGHT_INCHES,
  ne as CASE_IMAGE_JOB_MAX_POLLS,
  te as CASE_IMAGE_JOB_POLL_INTERVAL_MS,
  ct as CASE_IMAGE_JOB_STATUS_KEY,
  _t as CASE_IMAGE_JOB_STATUS_VALUE,
  W as CASE_IMAGE_MAX_HEIGHT,
  Z as CASE_IMAGE_MAX_QUALITY,
  X as CASE_IMAGE_MAX_WIDTH,
  f as CASE_IMAGE_VARIANT_ERROR_CODE,
  Et as CASE_IMAGE_VARIANT_KIND_KEY,
  mt as CASE_IMAGE_VARIANT_KIND_VALUE,
  se as CASE_IMAGE_VARIANT_POLL_INTERVAL_MS,
  fe as CASE_MODAL_TAB_KEYS,
  L as CLOSED_DESIGN_REQUEST_STATUSES,
  an as COMBINED_PDF_GENERATION_TIMEOUT_MS,
  tn as CSS_PX_PER_PT,
  Vt as DEFAULT_FONT_COLOR,
  gt as DEFAULT_LOCALE_CODE,
  Re as DESIGNER_ACTIVITY_POLL_MS,
  Pe as DESIGNER_CHAT_POLL_MS,
  F as DESIGNER_FLOW_STATUSES,
  P as DESIGNER_FLOW_STEP_ORDER,
  l as DESIGNER_OPTION_FLOWS,
  b as DESIGNER_OPTION_LABEL_ALIASES,
  Ue as DESIGNER_SPACE_LABELS,
  Bt as DESIGNER_SPACE_QUEUE_PATH,
  Gt as DESIGNER_STEP_STATUS,
  Le as DESIGN_CLOSED_AT_FORMAT,
  Ge as DESIGN_NOTIFY_DELAY_MS,
  T as DESIGN_REQUEST_NOTIFY_JOB,
  Ht as DESIGN_REQUEST_QUEUE_BUCKETS,
  o as DESIGN_TIME_UNIT_MINUTES,
  Pt as DESIGN_TIME_UNIT_PRICE_CENTS,
  ze as DIGNITY_DIRECT,
  kt as EDITOR_ACTIVE_BORDER_WIDTH,
  xt as EDITOR_INACTIVE_BORDER_WIDTH,
  He as EDITOR_USER_ROLE,
  O as EDIT_SESSION_ACCESS_PARAM,
  be as EDIT_SESSION_TOKEN_ACCESS,
  p as EDIT_SESSION_TOKEN_ACCESS_VALUES,
  $e as EDIT_TOKEN_HEADER,
  ve as EDIT_TOKEN_ROLE,
  Ye as EDIT_TOKEN_STORAGE_KEYS,
  g as ERROR_CODE,
  nt as EventCategory,
  on as FONT_LOAD_FAILED_REASON,
  Xt as GS_FLATTEN_FLAGS,
  Kt as GS_FONTPATH,
  z as IMAGE_MIME_WILDCARD,
  ae as IMAGE_PLACEHOLDER_REGEX,
  K as IMAGE_QUALITY_BANNER_PPI_THRESHOLD,
  S as IMAGE_QUALITY_PAPER_PPI_THRESHOLD,
  Ne as JWT_SHAPE,
  qt as LAUNCH_FLAGS,
  Qt as LAUNCH_TIMEOUT_MS,
  Qe as LAYOUT_SAVER_HAS_NO_FUNERAL_HOME_REASON,
  we as LEGACY_QC_SHADOW_ACCESS,
  D as LOCALE,
  ht as LOCALE_DISPLAY_NAMES,
  ft as LOCALE_MAP,
  Rt as LOCALE_OPTIONS,
  R as LOCALE_OPTIONS_MAP,
  Nt as LOCALE_TRANSLATED_DISPLAY_NAMES,
  Dt as LOCALE_VALUES,
  xe as LOTUS_FUNERAL_HOME_NOT_ENABLED_CODE,
  qe as LOTUS_GLOBAL_TEMPLATE_REFUSED_CODE,
  tt as LogLevel,
  Ke as M3,
  Je as M3_SPECIALTY_CARDS_CATEGORY_ID,
  Ze as M3_TUKIOS_CATEGORY_ID,
  G as MAX_ADDITIONAL_PHOTOS,
  ge as MAX_FILLED_CASE_IMAGES,
  y as MAX_PHOTO_EDITS,
  Q as MAX_UPLOAD_FILE_SIZE,
  Xe as MDL,
  j as MIO_ANALYSIS_HEIGHT,
  ee as MIO_ANALYSIS_QUALITY,
  J as MIO_ANALYSIS_WIDTH,
  oe as NON_EDITABLE_IMAGE_SUBTYPES,
  Ve as ORDER_PAGE_GONE_CODE,
  ke as ORDER_PAGE_TURNED_OVER_CODE,
  je as PAGE_ITEM_TYPES,
  B as PDF_FONTS_CONTRACT_ATTR,
  nn as PDF_FONTS_CONTRACT_MARK,
  $ as PDF_FONTS_CONTRACT_VERSION,
  sn as PDF_GENERATION_TIMEOUT_MS,
  Wt as PDF_KEY_SEGMENT_PATTERN,
  pt as PDF_PROCESSOR_TYPE,
  It as PDF_PROGRESS_STAGES,
  s as PDF_PROGRESS_STAGE_NAMES,
  St as PDF_STATUS_KEY,
  Tt as PDF_STATUS_VALUE,
  zt as PRINT_TO_PDF_BASE,
  et as PRODUCT_DEFAULT_DPI,
  ye as PROOF_NOTE_MAX_LENGTH,
  u as PROOF_PDF_MAX_BYTES,
  d as PROOF_PDF_MAX_MB,
  Ce as PROOF_PDF_MAX_PAGES,
  I as PROOF_PDF_RASTERIZE_JOB,
  at as PROOF_SHARE_FINALIZE_JOB,
  en as QPDF_SUCCESS_EXIT_CODES,
  Zt as RENDER_FETCH_ALLOWED_HOSTS,
  jt as RENDER_FETCH_ALLOWED_S3_BUCKETS,
  Jt as RENDER_FETCH_PATH_STYLE_S3_HOST,
  ot as SCREENSHOT_JOB_FAILED_REASON,
  rt as SENTRY_DENY_URLS,
  it as SENTRY_IGNORE_ERRORS,
  _ as SIGNATURE_BY_BERYL_LABEL,
  ut as STATUS_KEY,
  Ot as STATUS_VALUE,
  dt as TEXT_ENTRY_INTENT_ATTRIBUTES,
  We as TUKIOS_API_ORIGIN,
  de as UPSCALE_MAX_ASPECT_RATIO,
  ce as UPSCALE_MODEL_TIMEOUT_MS,
  le as UPSCALE_TARGET_MAX_EDGE_PX,
  re as UPSCALE_TARGET_MAX_PIXELS,
  ie as UPSCALE_TARGET_PPI,
  q as aiAlterationKindForOptionId,
  he as applicationTypes,
  _e as caseFormSections,
  Te as caseFormSectionsLabels,
  Fe as designNotifyJobId,
  c as designTimeUnits,
  Lt as designerServiceLinePrice,
  Yt as firstFamily,
  ue as formFieldAllowedInputs,
  Se as formFieldKeys,
  Ae as formFieldTypes,
  Ut as hasSignatureByBerylService,
  yt as isAdditionalPhotosComplete,
  At as isCaseImageVariantErrorCode,
  C as isClosedDesignRequestStatus,
  U as isDesignerFlowStatus,
  Ft as isDesignerManagedLine,
  Mt as isPhotoEditsComplete,
  M as isProofApprovedDesignRequestStatus,
  Be as isTokenizedEditSession,
  Ee as nameComponents,
  me as nameComponentsFormatted,
  Oe as newObjects,
  vt as promptForOption,
  bt as promptsForOptions,
  Me as proofPdfRasterizeJobId,
  Ct as serviceTimeCharge,
  pe as specialFieldBehaviors,
  wt as stepsForOptions,
  Ie as typeKeys,
  $t as userTypes
};
